<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Sz4vC1/images/cover.jpg?1726444355258" alt="This image is the cover for the book Quiz Actually"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quiz Actually
      </h1>
      <p class="bookDescription body article font2">
        <p><b>With this entertaining quiz book, you can test your knowledge of beloved Christmas movies from <i>Elf </i>and <i>The Grinch</i> to <i>Love, Actually</i> and even <i>Die Hard</i>!</b></p><p> If Christmas movies hold a special place in your heart—and your favorite scenes, lines, and trivia facts hold a special place in your memory—you’ll love this festive family film trivia book. From rating the best (and worst) examples of the genre, to what even makes a “Christmas movie”, <i>Quiz Actually</i> is sure to spark lively debate around the holiday dinner table. </p> Packed full of fun and tricky trivia questions, <i>Quiz Actually </i>will test your knowledge of the movies we watch every holiday season—from old time favorites like <i>It’s a Wonderful Life</i> and <i>Miracle on 34th Street</i> to modern classics like <i>Scrooged</i>, <i>The Nightmare Before Christmas</i>, and many more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe Shooman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?489b7274